// /api/contactService.js
import axiosInstance from './axiosInstance';

export default {
  // Get all contacts with pagination
  getAllContacts(page = 1, size = 10) {
    return axiosInstance.get('/contacts/accounts', {
      params: {
        page,
        size,
      },
    });
  },
  // Search contacts
  searchContacts(query, page = 1, size = 10) {
    return axiosInstance.get('/contacts/accounts/search', {
      params: {
        query,
        page,
        size,
      },
    });
  },
    // Search contacts within a project
    searchProjectContacts(projectId, query, page = 1, size = 10) {
      return axiosInstance.get(`/contacts/projects/search/${projectId}`, {
        params: {
          query,
          page,
          size,
        },
      });
    },
  // Get contacts by project ID
  getContactsByProjectId(projectId) {
    return axiosInstance.get(`/contacts/projects/${projectId}?page=1&size=100`);
  },
  addStakeholdersToProject(projectId, stakeholderIds) {
    return axiosInstance.post(`/contacts/projects/${projectId}/add`, {
      stakeholder_ids: stakeholderIds,
    });
  },
  // Create a new contact
  createContact(contactData) {
    return axiosInstance.post('/contacts/', contactData);
  },
  async getContactById(stakeholderId) {
    return await axiosInstance.get(`/contacts/${stakeholderId}`);
  },
  
  // Update a contact
  async updateContact(stakeholderId, contactData) {
    return await axiosInstance.put(`/contacts/${stakeholderId}`, contactData);
  },
  // Delete a contact
  deleteContact(stakeholderId) {
    return axiosInstance.delete(`/contacts/${stakeholderId}`);
  },
  deleteContactFromProject(projectId, stakeholderId) {
    return axiosInstance.delete(`/contacts/projects/${projectId}/remove/${stakeholderId}`);
  },
  uploadContactImage(contactId, image) {
    const formData = new FormData();
    formData.append('file', image);
    return axiosInstance.post(`/contacts/${contactId}/upload_profile_image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  removeContactImage(contactId) {
    return axiosInstance.delete(`/contacts/${contactId}/remove_profile_image`);
  },
  mergeContacts(data) {
    return axiosInstance.post(`/contacts/merge`, data);
  },
 
};
